<template>

</template>

<script>
import logoUrl from "../assets/image/logo.png";

export default {
  data() {
    return {
      projectLoginName: "智慧监测系统",
      logoMainUrl: logoUrl,
      form: {
        username: "",
        password: "",
        code: "",
      },
      checked: false,
      loadingLogin: false,
      isLoading: false,
      copyrightSwitch: null,
      projectCode: null,
      logoMainWidth: "5rem"
    }
  },
  mounted() {
    // this.projectCode = this.$getUrlParams("projectCode")
    const {un, pw, projectCode} = this.$route.query;
    localStorage.setItem("projectCode", projectCode)
    if (projectCode) {
      this.getProjectInfo()
    }
    this.form = {username: un, password: pw, code: "",},
      this.$axios.post("api/auth/auth/login", this.form).then(res => {
        const login_code = res.data.status;
        if (login_code !== 200) {
          this.$message({
            message: res.data.message,
            type: "warning",
            // duration:80000
          });
          this.loadingLogin = false
          return
        }
        const token = res.data.datas.values;
        localStorage.setItem("token", token);
        localStorage.setItem("username", this.form.username);
        // return;
        this.$axios.get("api/monitor/index/checkExistProject").then(res => {
          if (res.data.status == 200) {
            this.loadingLogin = false
            this.$router.push({name: "ProjectChoose"})
          } else {
            this.loadingLogin = false
            sessionStorage.setItem("cursor", "4")
            sessionStorage.setItem("isSelect", "menu5")
            localStorage.setItem("systemType", "2")
            localStorage.setItem("path", "")
            this.$router.push({name: "ProjectInfo"})
          }
        }).catch(() => {
          this.loadingLogin = false
        })
      }).catch(() => {
        this.loadingLogin = false
      })

  },
  methods: {
    getProjectInfo() {
      this.$axios.get("api/monitor/anonymous/channelInfo", {
        params: {
          channelCode: localStorage.getItem("projectCode")
        }
      }).then(res => {
        this.isLoading = true
        let data = res.data
        if (data.datas) {
          if (data.datas.values) {
            let values = data.datas.values
            this.logoMainUrl = values.logoMainUrl
            this.projectLoginName = values.projectLoginName
            this.copyrightSwitch = values.copyrightSwitch
            let string = values.extJsonInfo
            if (string) {
              let obj = JSON.parse(string)
              if (obj.logoMainWidth) {
                this.logoMainWidth = obj.logoMainWidth / 100 + "rem"
              }
            }
          }
        }
      }).catch(() => {

      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AutoLogin.vue